import { processMetatdata } from '../../../utils/dataTransformations';

/** Process search results for display. */

export default function processSearchResults(results) {
  return results.map(el => processMetatdata(el));
}
